import { namespacesLoader, withNamespaces } from '@/i18n/route-namespaces'
import { ProjectLayout } from '@/layouts'

export const projectRoutes = {
  path: 'projects/:projectId',
  element: <ProjectLayout />,
  loader: namespacesLoader(['projects']),
  children: [
    {
      path: 'bots',
      lazy: withNamespaces(['bots'], async () => {
        const { BotsSession } = await import('@/pages/dashboard/sessions/bots')

        return { Component: BotsSession }
      }),
      children: [
        {
          index: true,
          lazy: withNamespaces(['bots', 'projects'], async () => {
            const { BotsList } = await import(
              '@/pages/dashboard/sessions/bots/list'
            )

            return { Component: BotsList }
          }),
        },
      ],
    },
    {
      path: 'settings',
      lazy: withNamespaces(['bots', 'projects'], async () => {
        const { ProjectSettingsSession } = await import(
          '@/pages/dashboard/sessions/projects/settings'
        )

        return { Component: ProjectSettingsSession }
      }),
    },
  ],
}
